import * as signalR from '@microsoft/signalr';
import { SET_SIGNALR_CONNECTION_CONTEST, RECEIVE_AUTH_TOKEN } from './redux/constants';
import { signalRConnectedAction, signalRDisconnectedAction, fetchAuthToken } from './redux/setSignalRContestConnection';
import { receivedActiveContestEventAgents } from './redux/fetchActiveContestEventAgents';
import { receivedContestEventResults } from './redux/fetchContestEventResults';

const isLocal = false //process.env.NODE_ENV === 'development';

const signalRMiddlewareContests = ({ dispatch, getState }) => next => async (action) => {
  let connect = false;
  let agent_id = null;
  let state = getState();

  if (state && state.common && state.common.user) {
    agent_id = state.common.user.userID

    if(agent_id) {
      if (action.type === SET_SIGNALR_CONNECTION_CONTEST) {
        if (state.contests && !state.contests.signalRConnected) {
          connect = true;
          agent_id = state.common.user.userID
        }
    
        if (connect) {
          if (isLocal) initiateConnection('', dispatch, getState, agent_id);
          else dispatch(fetchAuthToken());
        }
      }
    
      if(action.type === RECEIVE_AUTH_TOKEN) {
        if(agent_id) {
          initiateConnection(action.authToken, dispatch, getState, agent_id);
        }
      }
    }
  }

  return next(action);
}

const initiateConnection = (token, dispatch, getState, agent_id) => {
  let signalRHubURL = process.env.REACT_APP_CONTEST_SIGNALR_URL;
  let signalRToken = isLocal ? '' : token;

  const connection = new signalR.HubConnectionBuilder()
    .withUrl(signalRHubURL + '?agent_id=' + agent_id, { 
      skipNegotiation: true, 
      transport: signalR.HttpTransportType.WebSockets,
      accessTokenFactory: () => signalRToken})
    .build();

  connection.on("ReceiveAgentContestEvents", (data) => {
    let state = getState();

    if (state && state.contests && !state.contests.signalRConnected) {
      dispatch(signalRConnectedAction());
    }

    //need to match contest event id to socket data.
    if (state && state.contests) {
      dispatch(receivedActiveContestEventAgents(data));
    }
  })

  connection.on("ReceiveContestEventResults", (contestEventId, data) => {
    let state = getState();
    if (state && state.contests && !state.contests.signalRConnected) {
      dispatch(signalRConnectedAction());
    }
    //need to match contest event id to socket data.
    if (state && state.contests) {
      dispatch(receivedContestEventResults(data));
    }
  })

  connection.onclose(async () => {
    dispatch(signalRDisconnectedAction());
    let state = getState();

    if (state && state.common && state.common.user) {
      const agent_id = state.common.user.userID;

      if (isLocal) initiateConnection('', dispatch, getState, agent_id);
      else dispatch(fetchAuthToken());
    }
  });

  async function start() {
    try {
      await connection.start();
    } catch (e) {
      console.error(e);
      setTimeout(() => start(), 5000);
    }
  };

  start();
}

export default signalRMiddlewareContests;


// WEBPACK FOOTER //
// ./src/features/contests/signalRMiddlewareContests.js